import { createCrudContext } from "./_lib/createCrudContext";

const { Provider, useValue } = createCrudContext({
  name: "tourPackage",
  listPath: "tour/package",
  adminPath: "tour/package",
  fetchOne: true,
  legacy: {
    data: "tourPackages",
    count: "count",
    selected: "tourPackage",
    setSelected: "setTourPackage",
    fetch: "fetchTourPackages",
    fetchOne: "fetchOneTour",
    create: "createOneTourPackage",
    update: "updateTourPackage",
    remove: "deleteTourPackage",
    updateState: "updateTourPackageState",
  },
});

export const TourPackageProvider = Provider;
export const useTourPackageContext = useValue;
